
















import Vue from 'vue'

export default Vue.extend({
  name: 'NotFound',
  computed: {
    anchorCancer (): string {
      return require('@/UI/Assets/anchor_cancer_bg.png')
    },
    anchorLine (): string {
      return require('@/UI/Assets/cancer_anchor_line_bg.png')
    },
    currentLocation (): string {
      const rawString = window.location.href.replace(this.$route.path, '')
      return rawString + '/login-response'
    }
  }
})
